import { NewsletterPromo } from '../../Components/NewsletterPromo/NewsletterPromo'

/* In the event the /blog route doesn't redirect server-side to Substack, show this component. */
export const Blog = () => (<div id='blog'>
    <NewsletterPromo width='normal' />
</div>)